const BI_DATA_WAREHOUSE_TABLE_COLUMN_COUNT = {
  ACCOUNTING_TRANSACTION_ADJUSTMENT: 11,
  ATA_ACCOUNT_DEFINITION: 5,
  ATA_GL_TRANSACTION: 11,
  DTC_INVOICE: 16,
  DTC_STORE: 12,
  HUB_SPOKE_STORE_MAPPING: 4,
  LOCATION: 14,
  WORK_ORDER: 27,
}

const BI_DATA_WAREHOUSE_TABLE_NAMES = {
  ACCOUNTING_TRANSACTION_ADJUSTMENT: 'Accounting Transaction Adjustment',
  ATA_ACCOUNT_DEFINITION: 'ATA Account Definition',
  ATA_GL_TRANSACTION: 'ATA GL Transaction',
  DTC_INVOICE: 'DTC Invoice',
  DTC_STORE: 'DTC Store',
  HUB_SPOKE_STORE_MAPPING: 'Hub Spoke Store Mapping',
  LOCATION: 'Location',
  WORK_ORDER: 'Work Order',
}

const BI_REPORT_MODAL_DISPLAY_MODES = {
  EDIT: 'edit',
  DELETE: 'delete',
} as const

type ValueOf<T> = T[keyof T]

export type BiReportModalDisplayModes = ValueOf<
  typeof BI_REPORT_MODAL_DISPLAY_MODES
>

export {
  BI_DATA_WAREHOUSE_TABLE_COLUMN_COUNT,
  BI_DATA_WAREHOUSE_TABLE_NAMES,
  BI_REPORT_MODAL_DISPLAY_MODES,
}
